(function () {
  'use strict';

  function normalizeText(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getWidth(value) {
    var text = (value || '').replace(/,/g, '.');

    var match = text.match(
      /(?:^|[^0-9])(0\.\d{1,2}|1\.\d{1,2}|2\.\d{1,2})\s*m(?:\b|$)/i
    );

    if (!match) {
      match = text.match(
        /(?:^|[-_])(0|1|2)[-_](\d{2})m(?:\b|[-_]|$)/i
      );

      if (match) {
        return parseFloat(match[1] + '.' + match[2]);
      }
    }

    return match ? parseFloat(match[1]) : null;
  }

  function formatWidth(width) {
    return (
      width
        .toFixed(2)
        .replace('.', ',')
        .replace(/,00$/, '') + ' m'
    );
  }

  function removeWidthFromTitle(title) {
    return normalizeText(
      (title || '')
        .replace(
          /(?:^|[\s\-–—|])(?:0|1|2)[.,]\d{1,2}\s*m(?:\b|$)/gi,
          ' '
        )
        .replace(
          /(?:^|[\s\-–—|])(?:0|1|2)[-_]\d{2}m(?:\b|$)/gi,
          ' '
        )
    );
  }

  function cleanUrl(url) {
    try {
      return new URL(url, window.location.origin)
        .pathname
        .replace(/\/$/, '');
    } catch (error) {
      return (url || '')
        .split('?')[0]
        .replace(/\/$/, '');
    }
  }

  function initializeWidthSwitcher(container) {
    if (container.dataset.cpWidthInitialized === 'true') {
      return;
    }

    container.dataset.cpWidthInitialized = 'true';

    var baseTitleRaw = container.dataset.baseTitle || '';
    var currentTitle = container.dataset.currentTitle || '';
    var currentUrl =
      container.dataset.currentUrl || window.location.pathname;

    var baseTitle = normalizeText(baseTitleRaw);
    var currentFamily = removeWidthFromTitle(currentTitle);

    if (!baseTitle && !currentFamily) {
      return;
    }

    var shopRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    var searchTerm = baseTitleRaw || currentTitle;

    var searchUrl =
      shopRoot +
      'search/suggest.json?q=' +
      encodeURIComponent(searchTerm) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=show' +
      '&resources[options][fields]=title';

    fetch(searchUrl, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Erreur de recherche Shopify : ' + response.status
          );
        }

        return response.json();
      })
      .then(function (data) {
        var products =
          data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products
            ? data.resources.results.products.slice()
            : [];

        products.push({
          title: currentTitle,
          url: currentUrl
        });

        var productsByWidth = {};

        products.forEach(function (product) {
          if (!product || !product.title || !product.url) {
            return;
          }

          var width =
            getWidth(product.title) || getWidth(product.url);

          if (!width) {
            return;
          }

          var productFamily = removeWidthFromTitle(product.title);

          var sameFamily =
            productFamily === currentFamily ||
            productFamily.indexOf(currentFamily) !== -1 ||
            currentFamily.indexOf(productFamily) !== -1 ||
            productFamily.indexOf(baseTitle) !== -1 ||
            baseTitle.indexOf(productFamily) !== -1;

          if (!sameFamily) {
            return;
          }

          productsByWidth[width.toFixed(2)] = {
            width: width,
            url: product.url,
            title: product.title
          };
        });

        var widthProducts = Object.keys(productsByWidth)
          .map(function (key) {
            return productsByWidth[key];
          })
          .sort(function (productA, productB) {
            return productA.width - productB.width;
          });

        if (widthProducts.length < 2) {
          return;
        }

        var buttonsContainer = container.querySelector(
          '.cp-width-switcher-buttons'
        );

        if (!buttonsContainer) {
          return;
        }

        buttonsContainer.innerHTML = '';

        var currentWidth = getWidth(currentTitle);
        var normalizedCurrentUrl = cleanUrl(currentUrl);

        widthProducts.forEach(function (product) {
          var link = document.createElement('a');
          var normalizedProductUrl = cleanUrl(product.url);

          var isActive =
            normalizedProductUrl === normalizedCurrentUrl ||
            (
              currentWidth !== null &&
              Math.abs(currentWidth - product.width) < 0.001
            );

          link.href = product.url;

          /*
           * Ouvre la fiche de l’autre laize
           * dans un nouvel onglet.
           */
          link.target = '_blank';
          link.rel = 'noopener noreferrer';

          link.className =
            'cp-width-switcher-btn' +
            (isActive ? ' is-active' : '');

          link.setAttribute(
            'aria-label',
            isActive
              ? 'Laize ' +
                  formatWidth(product.width) +
                  ' actuellement sélectionnée'
              : 'Ouvrir la laize ' +
                  formatWidth(product.width) +
                  ' dans un nouvel onglet'
          );

          if (isActive) {
            link.setAttribute('aria-current', 'page');
          }

          var widthLabel = document.createElement('b');
          widthLabel.textContent = formatWidth(product.width);

          link.appendChild(widthLabel);

          if (isActive) {
            var selectedLabel = document.createElement('small');
            selectedLabel.textContent = '✓ Sélectionnée';
            link.appendChild(selectedLabel);
          }

          buttonsContainer.appendChild(link);
        });

        container.hidden = false;
      })
      .catch(function (error) {
        console.warn(
          '[Coverprint] Sélecteur automatique de laizes :',
          error
        );
      });
  }

  function runWidthSwitchers(root) {
    var scope = root || document;

    scope
      .querySelectorAll('[data-cp-width-switcher]')
      .forEach(function (container) {
        initializeWidthSwitcher(container);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runWidthSwitchers(document);
    });
  } else {
    runWidthSwitchers(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      runWidthSwitchers(event.target);
    }
  );
})();